<template>
	<colleague-finder></colleague-finder>
</template>
<script>
	import { ref, inject } from "vue";
	import colleagueFinder from "@/components/webComponents/widget/colleagueFinder/colleagueFinder.vue";

	export default {
		components: {
			colleagueFinder
		},
		props: {},
		setup(props, context) {
			return {};
		}
	};
</script>